var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_21458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6582 2.9552L6.73314 14.2037C6.41361 14.6586 5.90855 14.9485 5.3833 14.991C5.27633 14.9996 5.27633 14.9996 5.19901 15.0003C4.70162 15.0003 4.22314 14.8029 3.87324 14.4511L0.550593 11.1284C-0.183325 10.3964 -0.183325 9.20835 0.549358 8.47567C1.28132 7.7437 2.46894 7.7437 3.2009 8.47567L4.94949 10.2243L11.591 0.797729C12.1867 -0.0517026 13.3586 -0.254541 14.2058 0.34319C15.0513 0.939586 15.2548 2.10918 14.6582 2.9552Z",
    fill: "#00D285"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_21458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckMark);
export default __webpack_public_path__ + "static/media/green-check-mark.d0e3e41ce0f2ee930a1d9258f903dd1d.svg";
export { ForwardRef as ReactComponent };